import { AGTranslator } from './ag_translator';
import { IPhoto } from '../data_models/iphoto';

/**
 * Responsible to translate Instagram Assets Response Models to the Common model.
 * @export
 * @class InstagramIngTranslator
 */
export class InstagramIngTranslator {

    static getInstance(): InstagramIngTranslator {
        if (!InstagramIngTranslator.instance) {
            InstagramIngTranslator.instance = new InstagramIngTranslator();
        }
        return InstagramIngTranslator.instance;
    }
    private static instance: InstagramIngTranslator;

    translateInstagramPhoto(entity: any, accountId: string): IPhoto {
        const photo: any = {
            id: entity.id,
            documentId: entity.documentId,
            accountId: accountId,
            dataCenter: "AUS",
            name: "",
            size: 0,
            assetId: entity.id,
            url: entity.media_url,
            createDate: entity.dateTaken,
            updateDate: entity.dateTaken,
            dateTaken: entity.dateTaken,
            lrHeight: entity.height || 200,
            lrWidth: entity.width || 200,
            landscape: entity.width >= entity.height ? true : false,
            assetSource: "instagram",
            reportingMediaSource: "instagram"
        };
        return photo;
    }

    translateInstagramClusterPhoto = function (entity: any, accountId: string): IPhoto {
        const pasConvertedImage = InstagramIngTranslator.getInstance().translateInstagramPhoto(entity, accountId);
        const photo = AGTranslator.getInstance().translatePhoto(pasConvertedImage);
        return photo;
    };

    translateAlbumPhotos(response: any): any {
        let albumResponse = { albumPhotos: { entities: response } };
        let albumPhotos = AGTranslator.getInstance().translateOwnedAlbumPhotos(true, albumResponse);
        return albumPhotos;
    }
}
